<template>
    <el-table
        border
        stripe
        lazy
        row-key="id"
        :data="projects"
        :load="tableLoad"
        style="width: 100%">
        <el-table-column prop="id" label="ID"/>
        <el-table-column prop="name" label="名字"/>
        <el-table-column prop="description" label="description"/>
        <el-table-column prop="timeFrom" label="timeFrom"/>
        <el-table-column prop="timeTo" label="timeTo"/>

        <el-table-column label="子项目个数">
            <ProjectChildrenCount slot-scope="scope" :parentId="scope.row.id"/>
        </el-table-column>

        <el-table-column label="工单数量">
            <ProjectTicketCount slot-scope="scope" :projectId="scope.row.id"/>
        </el-table-column>

        <el-table-column label="createdAt" prop="createdAt"/>
        <el-table-column label="deletedAt" prop="deletedAt"/>

        <el-table-column label="操作">
            <template slot-scope="scope">
                <a :href="'../Setting/ProjectEdit?parentId=' + scope.row.id">添加子项目</a>
                <a :href="'../Setting/ProjectEdit?id=' + scope.row.id">修改</a>

                <a v-if="scope.row.deletedAt" @click="doUnDelete(scope.row)">恢复</a>
                <a v-else @click="doDelete(scope.row)">刪除</a>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    name: 'ProjectTable',

    props: ['projects'],

    methods: {
        doUnDelete() {
            alert('恢复 开发中');
        },

        doDelete() {
            alert('删除 开发中');
        },

        tableLoad(tree, treeNode, resolve) {
            console.log('#41 tableLoad', this, tree, treeNode, resolve);

            sdk.ProjectApi().listByParentId({
                parentId: tree.id
            }).then(res => {
                resolve(res || []);
            });
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/setting/ProjectTable.vue